var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data",style:({'padding-top': _vm.pt + 'px'})},[_c('img',{attrs:{"src":_vm.noData}}),_c('p',[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }